namespace RioERP.Orders {
    export interface RegisterStudentResponse extends Serenity.SaveResponse {
        status?: string;
        message?: string;
        key?: string;
    }
}
